import {
  CompositePropertyModel,
  CompositePropertyType,
} from '../../models/composite-property.model'
import { PropertyDefinitionModel } from '../../models/property-definition.model'

export class AssetRequiredPrimitivePropertiesIds {
  public static NAME = '73622f4a-b047-401e-9ab3-0479a1dbcc00'
  public static HEIGHT = '30acb676-1e26-4144-9ae1-56c626be37b7'
  public static WIDTH = '8fa85ee5-a1c2-4ec2-976c-0f1d5d159ba1'
  public static LENGTH = '30955755-cda5-4587-a6cf-fdec7637933f'
  public static INSTALLATIONDATE = '39ca5d4e-8c49-4987-9bc7-dd7c48e0f20a'
  public static EXECUTED = '2eedd1f0-e2f3-4079-a4e2-31c0caadfbea'
  // public static ELEMENT_CATEGORY = '5eff4e33-1881-492a-8a5d-af0412b564e0'
}

export class AssetRequiredCompositePropertiesIds {
  // public static ELEMENT_CATEGORY = '6ca0d517-000d-4cce-ad73-de4704dc8bbd'
}

export class AssetRequiredPrimitiveProperties {
  public static PRIMITIVE_PROPERTIES: PropertyDefinitionModel[] = [
    {
      Id: AssetRequiredPrimitivePropertiesIds.NAME,
      Name: 'Name',
      Type: 'text',
      IsArray: false,
      Unit: null,
    },
    {
      Id: AssetRequiredPrimitivePropertiesIds.HEIGHT,
      Name: 'Height',
      Type: 'number',
      IsArray: false,
      Unit: 'mm',
    },
    {
      Id: AssetRequiredPrimitivePropertiesIds.WIDTH,
      Name: 'Width',
      Type: 'number',
      IsArray: false,
      Unit: 'mm',
    },
    {
      Id: AssetRequiredPrimitivePropertiesIds.LENGTH,
      Name: 'Length',
      Type: 'number',
      IsArray: false,
      Unit: 'mm',
    },
    {
      Id: AssetRequiredPrimitivePropertiesIds.INSTALLATIONDATE,
      Name: 'Installation Date',
      Type: 'date',
      IsArray: false,
      Unit: null,
    },
    {
      Id: AssetRequiredPrimitivePropertiesIds.EXECUTED,
      Name: 'Executed',
      Type: 'yes/no',
      IsArray: false,
      Unit: null,
    },
    // {
    //   Id: AssetRequiredPrimitivePropertiesIds.ELEMENT_CATEGORY,
    //   Name: 'Element Category',
    //   Type: 'Element Category',
    //   IsArray: false,
    //   Unit: null
    // }
  ]
}

export class AssetRequiredCompositeProperties {
  public static COMPOSITE_PROPERTIES: CompositePropertyModel[] = [
    // {
    //   Id: AssetRequiredCompositePropertiesIds.ELEMENT_CATEGORY,
    //   TypeName: 'Element Category',
    //   CompositePropertyType: CompositePropertyType.Value,
    //   PropertyDefinitions: null,
    //   Values: [
    //     {
    //       Value: {
    //         [AssetRequiredPrimitivePropertiesIds.NAME]: "Protection",
    //         Value: "Protection"
    //       }
    //     },
    //     {
    //       Value: {
    //         [AssetRequiredPrimitivePropertiesIds.NAME]: "Structure",
    //         Value: "Structure"
    //       }
    //     }
    //   ]
    // }
  ]
}
